/*
* Palo Alto Theme - Custom JS
*/

(function() {

  var BASE_PRICE = null;
  var COMPARE_PRICE = null;
  var CURRENCY_SYMBOL = null;
  var SUBSCRIBE_DISCOUNT = 0.9; // 10% off, keep in sync with badge text

  var planQuantities = {
    '691952714054': 1,
    '693787164998': 2,
    '691952746822': 3
  };

  var planLabels = {
    '691952714054': { main: '1 tub', sub: 'every month' },
    '693787164998': { main: '2 tubs', sub: 'every 2 months' },
    '691952746822': { main: '3 tubs', sub: 'every 3 months' }
  };

  var planBadgeIds = {
    '691952714054': 'gigi-subscription-badge-text',
    '693787164998': 'gigi-subscription-badge-text-2',
    '691952746822': 'gigi-subscription-badge-text-3'
  };

  var badgeStyle = 'position:absolute;top:-12px;left:50%;transform:translateX(-50%);white-space:nowrap;display:inline-flex;align-items:center;gap:4px;background:#FAFAF7;color:#223B51;border:1.5px solid #223B51;font-size:9.2px;font-weight:600;letter-spacing:0.07em;text-transform:uppercase;padding:3px 8px 2px;border-radius:20px;z-index:10;line-height:1.6;';

  var giftIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#223B51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  function getSubscriptionBadgeText(planId) {
    var divId = planId ? planBadgeIds[planId] : 'gigi-subscription-badge-text';
    var el = document.getElementById(divId || 'gigi-subscription-badge-text');
    if (el) return el.getAttribute('data-badge-text') || '';
    return '';
  }

  function inject() {
    // Derive prices + currency from the one-time price element (most reliable across markets)
    if (BASE_PRICE === null || COMPARE_PRICE === null || CURRENCY_SYMBOL === null) {
      var oneTimePriceEl = document.querySelector('[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price');
      if (oneTimePriceEl && oneTimePriceEl.textContent.trim()) {
        var raw = oneTimePriceEl.textContent.trim();
        var symbol = raw.replace(/[\d.,\s]/g, '');
        var oneTimePrice = parseFloat(raw.replace(/[^0-9.]/g, ''));
        if (oneTimePrice > 0) {
          CURRENCY_SYMBOL = symbol || '\u20ac';
          COMPARE_PRICE = oneTimePrice;
          BASE_PRICE = +(oneTimePrice * SUBSCRIBE_DISCOUNT).toFixed(2);
        }
      }
    }

    // Labels
    Object.keys(planLabels).forEach(function(id) {
      var btn = document.getElementById('loop-widget-sp-button-id-' + id);
      if (!btn) return;
      if (!btn.querySelector('.gigi-card-label')) {
        btn.childNodes.forEach(function(node) {
          if (node.nodeType === 3) node.textContent = '';
        });
        var wrapper = document.createElement('span');
        wrapper.className = 'gigi-card-label';
        wrapper.style.cssText = 'display:block;text-align:center;';
        var main = document.createElement('span');
        main.style.cssText = 'display:block;font-size:13px;font-weight:700;color:#223B51;line-height:1.3;';
        main.textContent = planLabels[id].main;
        var sub = document.createElement('span');
        sub.style.cssText = 'display:block;font-size:11px;font-weight:400;color:rgba(34,59,81,0.6);line-height:1.4;margin-top:2px;';
        sub.textContent = planLabels[id].sub;
        wrapper.appendChild(main);
        wrapper.appendChild(sub);
        btn.appendChild(wrapper);
      }
    });

    // Most Popular badge
    var btn2 = document.getElementById('loop-widget-sp-button-id-693787164998');
    if (btn2 && !btn2.querySelector('.gigi-badge-popular')) {
      var badge = document.createElement('span');
      badge.className = 'gigi-badge-popular';
      badge.style.cssText = badgeStyle;
      badge.textContent = 'Most popular';
      btn2.appendChild(badge);
    }

    // Free Gift badge, driven by metafield
    var btn3 = document.getElementById('loop-widget-sp-button-id-691952746822');
    var giftEl = document.getElementById('gigi-free-gift-text');
    var giftText = giftEl ? (giftEl.getAttribute('data-badge-text') || '').trim() : '';
    if (btn3 && giftText && !btn3.querySelector('.gigi-badge-gift')) {
      var giftBadge = document.createElement('span');
      giftBadge.className = 'gigi-badge-gift';
      giftBadge.style.cssText = badgeStyle;
      giftBadge.innerHTML = giftIcon + ' ' + giftText;
      btn3.appendChild(giftBadge);
    }

    // Subscription badge, per selected plan
    var selected = document.querySelector('.loop-widget-sp-button.loop-widget-sp-button-selected');
    var activePlanId = selected ? selected.dataset.sellingPlanId : '691952714054';
    var badgeText = getSubscriptionBadgeText(activePlanId);
    var subHeader = document.querySelector('[data-loop-widget-selling-plan-group] .loop-widget-spg-label-discount-wrapper');
    if (subHeader) {
      var existing = document.querySelector('.gigi-sub-badge');
      if (!existing) {
        if (badgeText) {
          var subBadge = document.createElement('div');
          subBadge.className = 'gigi-sub-badge loop-widget-purchase-option-discount-badge';
          subBadge.textContent = badgeText;
          subHeader.appendChild(subBadge);
        }
      } else {
        existing.textContent = badgeText;
      }
    }

    // Price
    if (selected) {
      var planId = selected.dataset.sellingPlanId;
      var qty = planQuantities[planId] || 1;
      var symbol = CURRENCY_SYMBOL || '\u20ac';
      var priceEl = document.querySelector('.loop-widget-purchase-option-price:not([id*="onetime"])');
      if (priceEl && BASE_PRICE) priceEl.textContent = symbol + (BASE_PRICE * qty).toFixed(2);
      var compareEl = document.querySelector('.loop-widget-purchase-option-compare-at-price');
      if (compareEl) {
        if (COMPARE_PRICE > 0) {
          compareEl.textContent = symbol + (COMPARE_PRICE * qty).toFixed(2);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    // Quantity
    var quantityInput = document.querySelector('.product__form input[name="quantity"]');
    if (quantityInput) {
      var oneTime = document.querySelector('[data-loop-widget-onetime-purchase-option][aria-checked="true"]');
      if (oneTime) {
        if (quantityInput.value != 1) { quantityInput.value = 1; quantityInput.dispatchEvent(new Event('change', {bubbles:true})); }
      } else if (selected) {
        var newQty = planQuantities[selected.dataset.sellingPlanId] || 1;
        if (quantityInput.value != newQty) { quantityInput.value = newQty; quantityInput.dispatchEvent(new Event('change', {bubbles:true})); }
      }
    }

    // Expanded
    var subscribeSelected = document.querySelector('[data-loop-widget-selling-plan-group][aria-checked="true"]');
    if (subscribeSelected) {
      var spg = subscribeSelected.querySelector('.loop-widget-spg-container');
      if (spg && !spg.classList.contains('expanded')) spg.classList.add('expanded');
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var loopContainer = document.getElementById('loop-widget-container-id-8424653652294');
    var watchTarget = loopContainer || document.querySelector('.loop-widget-container') || document.body;
    var debounceTimer = null;

    new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(inject, 0);
    }).observe(watchTarget, { childList: true, subtree: true });

    document.querySelectorAll('.radio__label').forEach(function(label) {
      label.addEventListener('click', function() {
        setTimeout(inject, 200);
        setTimeout(inject, 500);
        setTimeout(inject, 900);
      });
    });

    setTimeout(inject, 500);
    setTimeout(inject, 1000);
  });

})();
